<template>
  <v-container grid-list-xl>
    <v-btn
      style="z-index: 9999"
      @click="hacerExamen()"
      fixed
      right
      bottom
      color="primary"
      class="mb-6 mt-4 mr-2"
      v-if="temasSelected.length > 0 || testsSelected.length > 0"
      >Hacer test<v-icon>mdi-note-text</v-icon>
    </v-btn>
    <!-- <v-btn
      style="z-index: 9999"
      @click="hacerExamen()"
      color="primary"
      class="mb-6 mt-4"
      v-if="temasSelected.length > 0 || testsSelected.length > 0"
      ><v-icon left>mdi-note-text</v-icon>Hacer test de los temas
      seleccionados</v-btn
    > -->
    <v-dialog v-if="usuario.admin" v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn color="yellow" class="ml-4 mb-6 mt-4" v-on="on"
          >Crear Test</v-btn
        >
        <v-btn color="yellow" class="ml-4 mb-6 mt-4" @click="crearTema"
          >Crear Tema</v-btn
        >
      </template>

      <v-card>
        <v-card-title>
          <span class="headline"> Nuevo test tema </span>
        </v-card-title>

        <v-card-text>
          <v-container fill-height>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="test.nombreTest"
                  required
                  label="Nombre del test"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="test.nombreTema"
                  :items="temas"
                  label="Seleccione el tema"
                  item-text="nombreTema"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="test.descripcion"
                  required
                  label="Descripción"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="cancelarAgregar"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="agregarTest"
            >Guardar y cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEdit" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"> Editar test </span>
        </v-card-title>

        <v-card-text>
          <v-container fill-height>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="test.nombreTest"
                  required
                  label="Título del test"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6"> </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="test.nombreTema"
                  :items="temas"
                  label="Seleccione el tema"
                  item-text="nombreTema"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="test.descripcion"
                  required
                  label="Descripción"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="test.porcentaje"
                  required
                  label="Porcentaje tema"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="test.porcentajeTest"
                  required
                  label="Porcentaje Test"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="cancelarEditar()"
            >Cancelar editar</v-btn
          >
          <v-btn color="blue darken-1" text @click="editarTest"
            >Guardar y cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogHacerExamen" max-width="500px" height="400px">
      <v-tabs v-model="modelTab" centered color="black">
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1"> Preguntas </v-tab>

        <v-tab href="#tab-2"> Corrección </v-tab>
        <v-tabs-items v-model="modelTab">
          <v-tab-item :value="'tab-' + 1">
            <v-card text>
              <v-card-text
                >Elija el número de preguntas que desea para el
                test</v-card-text
              >
              <v-list>
                <v-divider></v-divider>

                <v-list-item-group v-model="radioNumeroPreguntas" color="blue">
                  <v-list-item class="" :value="1">
                    <!--v-avatar color="indigo" size="40px">
                  <span class="white--text headline">25</span>
                </v-avatar-->
                    <v-list-item-content class="ml-3">
                      <v-list-item-title @click.prevent="changeTab"
                        >25 preguntas - <v-icon>mdi-timer</v-icon> 20
                        min.</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>

                  <v-list-item class="" :value="2">
                    <!--v-avatar color="indigo" size="40px">
                  <span class="white--text headline">50</span>
                </v-avatar-->
                    <v-list-item-content class="ml-3">
                      <v-list-item-title @click.prevent="changeTab"
                        >50 preguntas - <v-icon>mdi-timer</v-icon> 45
                        min.</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>

                  <v-list-item class="" :value="3">
                    <!--v-avatar color="indigo" size="40px">
                  <span class="white--text headline">100</span>
                </v-avatar-->
                    <v-list-item-content class="ml-3">
                      <v-list-item-title @click.prevent="changeTab"
                        >100 preguntas - <v-icon>mdi-timer</v-icon> 90
                        min.</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-' + 2">
            <v-card text>
              <v-card-text
                >Elija el modo de correción para realizar el test</v-card-text
              >
              <v-list>
                <v-divider></v-divider>

                <v-list-item-group v-model="radioModoCorreccion" color="blue">
                  <v-list-item class="" :value="1">
                    <!--v-avatar color="indigo" size="40px">
                  <span class="white--text headline">25</span>
                </v-avatar-->
                    <v-list-item-content class="ml-3">
                      <v-list-item-title
                        >Corregir al final del test</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>

                  <v-list-item class="" :value="2">
                    <!--v-avatar color="indigo" size="40px">
                  <span class="white--text headline">50</span>
                </v-avatar-->
                    <v-list-item-content class="ml-3">
                      <v-list-item-title
                        >Corregir pregunta a pregunta</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>

      <v-card>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="cancelarHacerExamen"
            ><v-icon color="error">mdi-close</v-icon> Cancelar</v-btn
          >
          <v-btn color="blue darken-1" text @click="hacerExamenBis()">
            <v-icon>mdi-note-text</v-icon> Hacer test</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCrearTema" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"> Nuevo tema </span>
        </v-card-title>

        <v-card-text>
          <v-container fill-height>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="tema.nombreTema"
                  required
                  label="Título del tema"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6"> </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="tema.numeroTema"
                  required
                  label="Número de Tema"
                ></v-text-field>
                <v-text-field
                  v-model="tema.descripcion"
                  required
                  label="Descripción"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="cancelarAgregar"
            ><v-icon color="error">mdi-close</v-icon> Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="agregarTema">
            <v-icon>mdi-content-save</v-icon> Guardar y cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEditTema" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"> Editar tema </span>
        </v-card-title>

        <v-card-text>
          <v-container fill-height>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="temaEdit.nombreTema"
                  required
                  label="Título del tema"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6"> </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="temaEdit.numeroTema"
                  required
                  label="Número de Tema"
                ></v-text-field>
                <v-text-field
                  v-model="temaEdit.descripcion"
                  required
                  label="Descripción"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="temaEdit.porcentaje"
                  required
                  label="Porcentaje tema"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="cancelarEditar()"
            >Cancelar editar</v-btn
          >
          <v-btn color="blue darken-1" text @click="editarTema"
            >Guardar y cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirm" max-width="290">
      <v-card>
        <v-card-title class="headline"
          >¿Está seguro que desea borrar el tema?</v-card-title
        >

        <v-card-text>
          Se borrarán todos los tests y todas las preguntas.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogConfirm = false">
            Cancelar
          </v-btn>

          <v-btn color="error" text @click="eliminarTema"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-item-group multiple>
      <v-expansion-panels multiple focusable popout>
        <v-expansion-panel
          column
          wrap
          v-for="(tema, indexTema) in temas"
          :key="indexTema"
        >
          <v-card :color="containsTema(tema) ? '#B2C6B2' : 'grey lighten-4'">
            <v-expansion-panel-header
              style="position: fixed, padding: 10px 5px"
            >
              <v-card-text>
                <v-tooltip bottom close-delay="2">
                  <template v-slot:activator="{ on }">
                    <v-chip
                      class="mt-3 max-width"
                      v-on="on"
                      @click.stop="selectTema(tema)"
                      label
                      color="grey lighten-4"
                      text-color="primary"
                    >
                      <v-icon left>
                        {{
                          containsTema(tema)
                            ? "mdi-checkbox-marked-outline"
                            : "mdi-checkbox-blank-outline"
                        }}</v-icon
                      >
                      {{ tema.numeroTema }}: {{ tema.nombreTema }}
                    </v-chip>

                    <v-chip
                      v-if="usuario.admin"
                      class="ml-3 mt-3"
                      @click="eliminarTemaDialog(tema)"
                      label
                      color="error"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-chip>
                    <v-chip
                      v-if="usuario.admin"
                      class="white--text ml-3 mt-3"
                      @click="editarTemaDialog(indexTema)"
                      label
                      color="light-green"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-chip>
                  </template>
                  <span>Seleccionar tema</span>
                </v-tooltip>

                <!-- v-chip
                    class="ml-3 mt-3"
                    @click="selectTema(tema.numeroTema)"
                    label
                    color="teal"
                    text-color="white"
                  >
                    <v-icon left>
                      {{
                        containsTema(tema.numeroTema)
                          ? "mdi-checkbox-marked-outline"
                          : "mdi-checkbox-blank-outline"
                      }}</v-icon
                    >Seleccionar tema
                  </v-chip -->
              </v-card-text>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-flex md12>
                <v-item-group multiple>
                  <v-container class="pa-0">
                    <v-layout
                      column
                      wrap
                      v-for="(item, indexTest) in tests"
                      :key="indexTest"
                    >
                      <!-- Aqui se puede cambiar el ancho de la card -->
                      <v-item>
                        <v-card
                          v-if="item.numeroTema == tema.numeroTema"
                          class="mb-3 ml-3 mr-3"
                          :color="
                            containsTest(item)
                              ? !containsTema(tema)
                                ? '#B2C6B2'
                                : 'grey lighten-4'
                              : 'grey lighten-4'
                          "
                        >
                          <v-card-text>
                            <v-chip-group>
                              <v-chip
                                @click="selectTest(item, tema)"
                                label
                                color="grey lighten-4"
                                text-color="primary"
                                class="ml-0 mb-3"
                              >
                                <v-icon left>
                                  {{
                                    containsTest(item)
                                      ? !containsTema(tema)
                                        ? "mdi-checkbox-marked-outline"
                                        : "mdi-checkbox-blank-outline"
                                      : "mdi-checkbox-blank-outline"
                                  }}</v-icon
                                >
                                <!-- {{ item.numeroTest }}. -->
                                {{ item.nombreTest }}
                              </v-chip>

                              <v-chip
                                v-if="usuario.admin"
                                @click="editarTestDialog(indexTest)"
                                label
                                class="white--text"
                                color="light-green"
                              >
                                <v-icon>mdi-pencil</v-icon>
                              </v-chip>
                              <v-chip
                                v-if="usuario.admin"
                                @click="eliminarTest(item)"
                                label
                                color="error"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-chip>
                              <!-- v-chip
                                class="ml-3"
                                @click="
                                  selectTest(item.numeroTest, tema.numeroTema)
                                "
                                label
                                color="teal"
                                text-color="white"
                              >
                                <v-icon left>
                                  {{
                                    containsTest(
                                      item.numeroTest + "," + tema.numeroTema
                                    )
                                      ? !containsTema(tema.numeroTema)
                                        ? "mdi-checkbox-marked-outline"
                                        : "mdi-checkbox-blank-outline"
                                      : "mdi-checkbox-blank-outline"
                                  }}</v-icon
                                >Seleccionar test
                              </v-chip -->
                            </v-chip-group>

                            <p class="font-weight-bold">
                              {{ item.descripcion }}
                            </p>

                            <!-- <v-btn :to="{ name: 'preguntas', params: { id: item }}" color="success" class="ml-0 mx-2" >Editar Preguntas</v-btn>
            -->
                            <v-chip
                              v-if="usuario.admin"
                              label
                              @click="editarPreguntas(item)"
                              color="light-green"
                              class="white--text ml-2 mt-2"
                            >
                              <v-icon left>mdi-pencil</v-icon>Editar preguntas
                            </v-chip>
                            <v-chip
                              label
                              v-if="checkHacerTest"
                              @click="hacerTestIndividual(tema, item)"
                              color="primary"
                              textColor="white"
                              class="ml-2 mt-2"
                            >
                              <v-icon left>mdi-note-text</v-icon>
                              Hacer test</v-chip
                            >
                          </v-card-text>
                        </v-card>
                      </v-item>
                    </v-layout>
                  </v-container>
                </v-item-group>
              </v-flex>
            </v-expansion-panel-content>
          </v-card>
          <!-- <v-flex md6 v-if="!formAgregar">
        <v-card class="mb-3 pa-5">
          <v-form @submit.prevent="editar">
            <v-text-field v-model="tema.nombreTema" label="Titulo del tema"></v-text-field>
            <v-text-field v-model="tema.tema" label="Numero del tema"></v-text-field>
            <v-textarea v-model="tema.descripcion" label="Descripción del tema"></v-textarea>
            <v-btn type="submit" class="ml-0 mx-2" color="warning">Editar tema</v-btn>
            <v-btn @click="cancelarEditar()" class="ml-0 mx-2" color="error">Cancelar</v-btn>

          </v-form>
        </v-card>
      </v-flex>

      <v-flex md6 v-if="formAgregar">
        <v-card class="mb-3 pa-5">
          <v-form @submit.prevent="agregarTema">
            <v-text-field v-model="tema.nombreTema" label="Título del tema"></v-text-field>
            <v-text-field v-model="tema.tema" label="Numero del tema"></v-text-field>

            <v-textarea v-model="tema.descripcion" label="Descripción del tema"></v-textarea>
            <v-btn type="submit" block color="success">Agregar tema</v-btn>
          </v-form>
        </v-card>
      </v-flex> -->
        </v-expansion-panel>
      </v-expansion-panels>
    </v-item-group>

    <v-snackbar v-model="snackbar">
      {{ mensaje }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { async } from "q";

export default {
  data: (vm) => ({
    modelTab: "tab-1",
    indexTema: -1,
    radioNumeroPreguntas: [],
    radioModoCorreccion: [],
    temasSelected: [],
    testsSelected: [],
    porcentajesSelected: [],
    temasLocal: [],
    tema: {},
    temaEdit: {},
    temaToDelete: {},
    test: {},
    testSelected: {
      type: Object,
      default: () => {},
    },
    dialog: false,
    dialogEdit: false,
    dialogCrearTema: false,
    dialogEditTema: false,
    dialogHacerExamen: false,
    dialogConfirm: false,
    snackbar: false,
    mensaje: "",
    formAgregar: true,

    indexTema: "",
  }),
  created() {
    console.log(this.$hostname);
    this.loadTests();

    this.loadTemas();
  },
  computed: {
    ...mapState(["usuario", "tests", "temas", "exist"]),
    ...mapGetters(["arrayFiltradoEntradas"]),
    sortedArray: function () {
      function compare(a, b) {
        if (a.numeroTest < b.numeroTest) return -1;
        if (a.numeroTest > b.numeroTest) return 1;
        return 0;
      }

      return this.tests.sort(compare);
    },
    checkHacerTest() {
      return !this.testsSelected.length > 0 && !this.temasSelected.length > 0;
    },
  },
  props: {},
  watch: {
    dialog(val) {
      val;
    },
    test() {},
    test: {
      handler(value) {
        this.temas.forEach((element) => {
          if (element.nombreTema == value.nombreTema) {
            this.test.numeroTema = element.numeroTema;
          }
        });
      },
    },
  },
  methods: {
    ...mapActions([
      "loadTests",
      "loadTemas",
      "saveTest",
      "editTest",
      "deleteTest",
      "saveTema",
      "deleteTema",
      "editTema",
    ]),
    changeTab() {
      this.modelTab = "tab-2";
    },
    crearTema: function () {
      this.dialogCrearTema = true;
    },
    async agregarTema() {
      if (this.tema.nombreTema === "" || this.tema.descripcion === "") {
        this.snackbar = true;
        this.mensaje = "Los campos están vacios";
      } else {
        this.tema.id = this.tema.numeroTema;
        console.log("tema nuevo");
        console.log(this.tema);
        await this.saveTema(this.tema);
        console.log("exist " + this.exist);

        if (this.exist) {
          console.log("dentro if exist");
          this.snackbar = true;
          this.mensaje = "Ese tema ya existe";
          this.$store.commit("setExist", false);
        } else {
          this.snackbar = true;
          this.mensaje = "Tema Agregada";
          //this.loadTemas();
        }

        /* this.listaTareas.push({
          id: Date.now(),
          titulo: this.titulo,
          descripcion: this.descripcion
        });
        */
        this.tema = {};
        this.dialog = false;
      }
    },
    eliminarTema() {
      /* this.listaTareas = this.listaTareas.filter(e => {
        return e.id != id;
      });
      */
      this.deleteTema(this.temaToDelete);
      this.dialogConfirm = false;
    },
    eliminarTemaDialog(tema) {
      /* this.listaTareas = this.listaTareas.filter(e => {
        return e.id != id;
      });
      */
      this.temaToDelete = tema;
      this.dialogConfirm = true;
    },
    editarTemaDialog(index) {
      this.formAgregar = false;
      console.log("elemento a editar index " + index);
      console.log(this.temas[index]);
      this.temaEdit.nombreTema = this.temas[index].nombreTema;
      this.temaEdit.numeroTema = this.temas[index].numeroTema;
      this.temaEdit.descripcion = this.temas[index].descripcion;
      this.temaEdit.porcentaje = this.temas[index].porcentaje;

      console.log("this.tema");
      console.log(this.temaEdit);
      this.indexTema = index;
      this.dialogEditTema = true;
    },
    editarTema() {
      this.temas[this.indexTema].nombreTema = this.temaEdit.nombreTema;
      this.temas[this.indexTema].numeroTema = this.temaEdit.numeroTema;
      this.temas[this.indexTema].descripcion =
        this.temaEdit.descripcion == null ? "" : this.temaEdit.descripcion;
      this.temas[this.indexTema].porcentaje = parseInt(
        this.temaEdit.porcentaje
      );

      console.log("edit Tema index" + this.indexTema);
      console.log(this.temas[this.indexTema]);
      this.editTema(this.temas[this.indexTema]);
      this.formAgregar = true;
      this.temaEdit = {};
      this.snackbar = true;
      this.mensaje = "Tema editado";
      this.dialogEditTema = false;
    },
    containsTema: function (numeroTema) {
      return this.temasSelected.includes(numeroTema);
    },
    containsTest: function (numeroTestnumeroTema) {
      return this.testsSelected.includes(numeroTestnumeroTema);
    },
    selectTema: function (tema) {
      if (this.temasSelected.includes(tema)) {
        this.temasSelected.splice(this.temasSelected.indexOf(tema), 1);
        this.porcentajesSelected.splice(
          this.porcentajesSelected.indexOf(tema.porcentaje),
          1
        );

        this.testsSelected = this.testsSelected.filter(
          (test) => test.numeroTema != tema.numeroTema
        );

        // this.testsSelected.forEach((test) => {
        //   if (test.numeroTema == tema.numeroTema) {
        //       this.testsSelected.splice(this.testsSelected.indexOf(test), 1);
        //   }
        // });
      } else {
        this.temasSelected.push(tema);
        this.porcentajesSelected.push(tema.porcentaje);

        this.tests.forEach((test) => {
          if (test.numeroTema == tema.numeroTema) {
            if (!this.testsSelected.includes(test)) {
              this.testsSelected.push(test);
            } else {
              this.porcentajesSelected.splice(
                this.porcentajesSelected.indexOf(test.porcentajeTest),
                1
              );
            }
          }
        });
      }
    },
    selectTest: function (test, tema) {
      if (this.temasSelected.includes(tema)) {
        this.temasSelected.splice(this.temasSelected.indexOf(tema), 1);
        this.porcentajesSelected.splice(
          this.porcentajesSelected.indexOf(tema.porcentaje),
          1
        );
        this.testsSelected = this.testsSelected.filter(
          (testSelected) => testSelected.numeroTema != tema.numeroTema
        );
      }

      if (this.testsSelected.includes(test)) {
        this.testsSelected.splice(this.testsSelected.indexOf(test), 1);
        this.porcentajesSelected.splice(
          this.porcentajesSelected.indexOf(test.porcentajeTest),
          1
        );
      } else {
        this.testsSelected.push(test);
        this.porcentajesSelected.push(test.porcentajeTest);
      }
    },
    selectTestViejo: function (indexTest, indexTema, id) {
      console.log("indexTema es " + indexTema);
      if (this.temasSelected.includes(indexTema)) {
        this.temasSelected.splice(this.temasSelected.indexOf(indexTema), 1);

        if (this.testsSelected.includes(indexTest + "," + indexTema)) {
          return;
        } else {
          console.log("1 Agrego " + indexTest + "," + indexTema);
          this.testsSelected.push(indexTest + "," + indexTema);
          return;
        }
        return;
      }

      if (this.testsSelected.includes(indexTest + "," + indexTema)) {
        console.log(
          "esta seleccionado ya, y lo elimino if " +
            indexTest +
            "" +
            indexTema +
            " en el index " +
            this.testsSelected.indexOf(indexTest)
        );
        console.log("el tamaño es" + this.testsSelected.length);
        this.testsSelected.splice(
          this.testsSelected.indexOf(indexTest + "," + indexTema),
          1
        );
        console.log(
          "el tamaño es despues de eliminar" + this.testsSelected.length
        );

        console.log(this.testsSelected.includes(indexTest + "," + indexTema));
      } else {
        console.log(this.testsSelected.length);
        console.log("no esta seleccionado else ");
        console.log("inserto el index es " + indexTest + "," + indexTema);
        this.testsSelected.push(indexTest + "," + indexTema);

        console.log("agrega el test ");
        console.log(this.testsSelected.length);
      }
    },
    unSelectTemaNoVale: function (indexTema, indexTest) {
      if (this.testsSelected.includes(indexTest)) {
        console.log("esta seleccionado ya, y lo elimino if ");
        this.testsSelected.splice(indexTest, 1);
      } else {
        console.log(this.testsSelected.length);
        console.log("no esta seleccionado else ");
        this.testsSelected.push(indexTest);

        console.log("agrega el test ");
        console.log(this.testsSelected.length);
      }
      this.temasSelected.splice(indexTema, 1);
    },
    async agregarTest() {
      if (this.test.nombreTest === "" || this.test.descripcion === "") {
        this.snackbar = true;
        this.mensaje = "Los campos están vacios";
      } else {
        if (this.tests.length === 0) {
          this.test.numeroTest = 1;
        } else {
          this.test.numeroTest =
            this.sortedArray[this.sortedArray.length - 1].numeroTest + 1;
        }
        // this.test.id = this.test.numeroTest;
        console.log("test nuevo");
        //this.test.temaId = this.tema.id
        console.log(this.test);
        await this.saveTest(this.test);
        console.log("exist " + this.exist);

        if (this.exist) {
          console.log("dentro if exist");
          this.snackbar = true;
          this.mensaje = "Ese test ya existe";
          this.$store.commit("setExist", false);
        } else {
          this.snackbar = true;
          this.mensaje = "Test Agregado";
          //this.loadTests();
        }

        /* this.listaTareas.push({
          id: Date.now(),
          titulo: this.titulo,
          descripcion: this.descripcion
        });
        */
        this.test = {};
        this.dialog = false;
      }
    },
    eliminarTest(tema) {
      /* this.listaTareas = this.listaTareas.filter(e => {
        return e.id != id;
      });
      */
      this.deleteTest(tema);
    },
    cancelarEditar() {
      this.formAgregar = !this.formAgregar;
      this.tema = {};
      this.dialogEdit = false;
      this.dialog = false;
      this.dialogEditTema = false;
    },
    cancelarAgregar() {
      this.formAgregar = !this.formAgregar;
      this.tema = {};
      this.dialogCrearTema = false;
      this.dialogEdit = false;
      this.dialog = false;
      this.dialogEditTema = false;
    },
    cancelarHacerExamen() {
      this.dialogHacerExamen = false;
    },
    editarPreguntas(temaParam) {
      // this.$route   ._links.self.href.split('/')[5]

      // this.$router.push({ name: 'preguntas', params: { id: '123' } })
      console.log("temaParam");
      console.log(temaParam);
      this.testSelected = temaParam;
      console.log("testSelected in Tests");
      console.log(this.testSelected);
      this.$router.push({
        name: "preguntas",
        params: { testSelected: this.testSelected },
      });

      //this.$router.push({ name: 'preguntas' })
    },
    hacerExamen(testParam) {
      // this.$route   ._links.self.href.split('/')[5]

      // this.$router.push({ name: 'preguntas', params: { id: '123' } })
      this.testSelected = testParam;
      this.dialogHacerExamen = true;

      //this.$router.push({ name: 'preguntas' })
    },
    hacerTestIndividual(tema, test) {
      this.selectTest(test, tema);
      this.dialogHacerExamen = true;

    },
    hacerExamenBis() {
      // this.$route   ._links.self.href.split('/')[5]

      // this.$router.push({ name: 'preguntas', params: { id: '123' } })
      console.log("this.radionumeroPReguntas " + this.radioNumeroPreguntas);
      console.log("this.radioModoCorreccion " + this.radioModoCorreccion);
      if (
        this.radioNumeroPreguntas.length == 0 ||
        this.radioModoCorreccion == 0
      ) {
        this.snackbar = true;
        this.mensaje = "Debe seleccionar el modo de correción";
        return;
      }

      console.log("this.testsSelected " + this.testsSelected);
      console.log("this.temasSelected " + this.temasSelected);
      var numeroPreguntas = 0;
      var timerCount = 0;

      switch (this.radioNumeroPreguntas) {
        case 1:
          console.log("25 preguntas");
          numeroPreguntas = 25;
          timerCount = 1200;
          break;
        case 2:
          numeroPreguntas = 50;
          timerCount = 2700;
          break;
        case 3:
          numeroPreguntas = 100;
          timerCount = 5400;
          break;

        default:
          break;
      }

      console.log("hacerExamen ");
      console.log(this.testSelected);
      console.log("porcentajesSelected")
      console.log(this.porcentajesSelected)
                    let total = this.porcentajesSelected.reduce((x, y) => x + y);

      if (total == 0){
        total = 100
      }


      console.log("Porcentaje Total in Tests.vue " + total);
      // let testsFiltered = [];
      // this.temasSelected.find((tema) => {
      //   this.testsSelected.find((test) => {
      //     let numTema = test.split(",")[1];
      //     if (tema == numTema) {
      //       testsFiltered.push(test);
      //     }
      //   });
      // });

      // console.log("testsFiltered");
      // console.log(testsFiltered);

      // console.log("testsSelected");
      // console.log(this.testsSelected);

      // testsFiltered.forEach((element) => {
      //   this.testsSelected.splice(this.testsSelected.indexOf(element), 1);
      // });

      // console.log(this.testsSelected);

      if (this.radioModoCorreccion == 1) {
        this.$router.push({
          name: "examen",
          params: {
            timerCountProp: timerCount,
            numeroPreguntas: numeroPreguntas,
            testSelected: this.testSelected,
            testsSelected: this.testsSelected,
            temasSelected: this.temasSelected,
            porcentajesSelected: total
          },
        });
      } else if (this.radioModoCorreccion == 2) {
        this.$router.push({
          name: "examen2",
          params: {
            timerCountProp: timerCount,
            numeroPreguntas: numeroPreguntas,
            testSelected: this.testSelected,
            testsSelected: this.testsSelected,
            temasSelected: this.temasSelected,
            porcentajesSelected: total
          },
        });
      }

      //this.$router.push({ name: 'preguntas' })
    },
    editarTestDialog(index) {
      this.formAgregar = false;
      console.log("elemento a editar");
      console.log(this.tests[index]);
      this.test.nombreTest = this.tests[index].nombreTest;
      this.test.nombreTema = this.tests[index].nombreTema;
      this.test.descripcion = this.tests[index].descripcion;
      this.test.porcentaje = this.tests[index].porcentaje;
      this.test.porcentajeTest = this.tests[index].porcentajeTest;

      console.log(this.tema);
      this.indexTema = index;
      this.dialogEdit = true;
    },
    editarTest() {
      console.log("Selected items");

      this.temasSelected.forEach((element) => {
        console.log(this.temas[parseInt(element, 10)]);
      });
      this.tests[this.indexTema].nombreTest = this.test.nombreTest;
      this.tests[this.indexTema].nombreTema = this.test.nombreTema;
      this.tests[this.indexTema].descripcion = this.test.descripcion;
      this.tests[this.indexTema].porcentaje = parseInt(this.test.porcentaje);
      this.tests[this.indexTema].porcentajeTest = parseInt(
        this.test.porcentajeTest
      );

      console.log("edit Test");
      console.log(this.tests[this.indexTema]);
      this.editTest(this.tests[this.indexTema]);
      this.formAgregar = true;
      this.nombreTema = "";
      this.tema = "";
      this.snackbar = true;
      this.mensaje = "Tema editada";
      this.dialogEdit = false;
    },
  },
};
</script>
